// import {v4 as uuid } from 'uuid';
import googleOAuthAPI from './oauthGoogleAPI';

async function syncGoogle (params) {
   // window.weblog(`syncStore.syncGoogle() syncing... ${JSON.stringify(params, 0, 4)}`);
   googleOAuthAPI(params);
}

export default syncGoogle;
